import { render, staticRenderFns } from "./TiptapV2.vue?vue&type=template&id=6d14673e"
import script from "./TiptapV2.vue?vue&type=script&lang=js"
export * from "./TiptapV2.vue?vue&type=script&lang=js"
import style0 from "./TiptapV2.vue?vue&type=style&index=0&id=6d14673e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports